export const patientInfo = {
  computed: {
    age() {
      if (!this.patient || !this.patient.birth_date) {
        return null
      }
      return this.moment().diff(this.moment(this.patient.birth_date), 'years')
    }
  },
  methods: {
    getAgeAtSpecificDate(specifiedDate, patientBirthDate) {
      if (!patientBirthDate) {
        return null
      }
      return this.moment(specifiedDate).diff(this.moment(patientBirthDate), 'years')
    }
  }
}
